// src/composables/useValidations.js
import { ref } from "vue";

export function useValidations() {
  let emailErrors = ref('');

  function validateEmail(email) {
    const emailRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;

    // Allow empty email during edit
    if (email == null || email === "") {
      emailErrors.value = "";
      return true;
    }

    if (!emailRegex.test(email)) {
      emailErrors.value = "El formato del email es inválido.";
      return false;
    }

    emailErrors.value = "";
    return true;
  }
  
  function calculateAge(dateString) {
    if (!dateString) return "";
  
    const normalized = dateString.replace(/-/g, "/");
    const [day, month, year] = normalized.split("/").map(Number);
  
    if (!day || !month || !year) return "";
  
    const today = new Date();
    let age = today.getFullYear() - year;
  
    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
      age--;
    }
  
    return age;
  }

  return {
    emailErrors,
    validateEmail,
    calculateAge
  };
}
